import { NOTIFICATION_TABS } from './notification-center.const'

/**
 * Returns the feed items after notification `id` has been read: removed on the Unread tab, flagged read elsewhere.
 * @param {object[]} items
 * @param {number} id
 * @param {string} tab
 */
export function applyNotificationRead(items, id, tab) {
  if (tab === NOTIFICATION_TABS.UNREAD) return items.filter(item => item.id !== id)
  return items.map(item => (item.id === id ? { ...item, status: 1 } : item))
}
